<template>
    <div class="container">
        <markerControl></markerControl>
        <polygonLegend></polygonLegend>
        <toggleState></toggleState>
        <circleRangeControl></circleRangeControl>

        <p class="control-block recommended-env">閲覧環境：1200*700px以上推奨</p>

        <div class="control-block de-logo">
          <h2>
            <a v-if="cityUrl" :href="cityUrl"><img src="@/assets/img/logo.png" alt="data eye（データアイ　データで紡ぐ高梁川流域連携事業）"></a>
            <a v-else href="http://dataeye.jp"><img src="@/assets/img/logo.png" alt="data eye（データアイ　データで紡ぐ高梁川流域連携事業）"></a>
          </h2>
        </div>
    </div>
</template>

<script>
import markerControl from "./marker-control";
import polygonLegend from "./polygon-legend";
import toggleState from "./toggle-state";
import circleRangeControl from "./circle-range-control";

export default {
    name: "control-panel",
    components: {
        markerControl,
        polygonLegend,
        toggleState,
        circleRangeControl
    },
    computed: {
        config () {
          return this.$store.state.config_from_api
        },
        cityUrl () {
          if(Object.keys(this.config).length){
            return this.config.cityConfig.cityUrl
          } else {
              return false
          }
        }
    }
}
</script>

<style scoped lang="scss">
.control-panel {
  position: absolute;
  z-index: 1;
  top: 10px;
  left: 10px;
  width: 260px;
  background: white;
  opacity: 0.95;
  font-size: 12px;
}

.control-block {
  padding: 5px;
}
.control-block.is-pd5 {
  padding-top: 5px;
  padding-bottom: 5px;
}

.fs10 {
  font-size: .8em;
  text-align: center;
}

.de-logo h2 {
  text-align: center;
}
.de-logo img {
  text-align: center;
  width: 100px;
}

.de-logo {
  border-top: 1px solid #eee;
  display: flex;
}
.de-logo a {
  line-height: 1;
}
.de-logo img {
  display: block;
  width: 100%;
}

.label-list {
  overflow: hidden;
}
.label-list li {
  box-sizing: border-box;
  float: left;
  width: 50%;
  padding: .2em 0;
}
.label-list li input {
  vertical-align: baseline;
}
</style>

